import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'highlightSemicolon'
})
export class HighlightSemicolonPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string | undefined): SafeHtml {
    if (!value) return '';
    const highlighted = value.replace(/;([^;]+);/g, '<span class="highlighted">$1</span>');

    return this.sanitizer.bypassSecurityTrustHtml(highlighted);
  }
}
